import { useRef } from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { motion, useInView } from "framer-motion";
import { Button } from "../ui/button";
import { useLanguage } from "../../contexts/LanguageContext";

export const AboutSection = () => {
  const { language, direction, translations: t } = useLanguage();
  const ArrowIcon = direction === 'rtl' ? ArrowLeft : ArrowRight;
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  return (
    <section id="about" className="py-20 md:py-28 bg-[#FAF7F2] scroll-mt-20" data-testid="about-section" ref={ref}>
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <motion.div
          className="text-center"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <span className="text-[#C4956A] font-semibold mb-2 block">{t.about.label}</span>
          <h2 className="font-['Heebo'] text-3xl md:text-4xl lg:text-5xl font-bold text-[#2C2C2C] mb-6">
            {t.about.title}
          </h2>
        </motion.div>

        <motion.div
          className="space-y-4 text-lg text-[#2C2C2C]/80 mb-8 text-center max-w-3xl mx-auto"
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          {t.about.paragraphs.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </motion.div>

        <motion.div
          className="flex justify-center"
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <a href="#contact">
            <Button className="rounded-full px-8 py-6 bg-[#C4956A] hover:bg-[#b38559] hover:scale-[1.02] text-white text-lg transition-all">
              {t.about.cta}
              <ArrowIcon className="w-5 h-5 mx-2" />
            </Button>
          </a>
        </motion.div>
      </div>
    </section>
  );
};
